/* Overlaid on the recipe/activity hero — anchored bottom-right. The hero sets
   position: relative. */
.root {
	position: absolute;
	right: var(--space-3);
	bottom: var(--space-3);
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	gap: var(--space-2);
	/* Above Leaflet's control containers (z-index 1000), which otherwise paint
	   over the button once the activity map initialises in the hero. */
	z-index: 1001;
}

.input {
	display: none;
}

.buttons {
	display: flex;
	gap: var(--space-2);
}

.button {
	display: inline-flex;
	align-items: center;
	gap: 6px;
	padding: 6px 12px;
	border-radius: var(--radius-md);
	border: none;
	background: color-mix(in srgb, black 55%, transparent);
	color: #fff;
	font: inherit;
	font-size: 0.8125rem;
	font-weight: 600;
	cursor: pointer;
	backdrop-filter: blur(4px);
	transition: background 0.1s ease;
}

.button:hover:not(:disabled) {
	background: color-mix(in srgb, black 70%, transparent);
}

.button:disabled {
	opacity: 0.6;
	cursor: not-allowed;
}

.remove {
	padding: 6px 10px;
}

.error {
	padding: 3px 8px;
	border-radius: var(--radius-sm);
	background: var(--accent-rose);
	color: #fff;
	font-size: 0.75rem;
	font-weight: 600;
}

.spin {
	animation: spin 0.8s linear infinite;
}

@keyframes spin {
	to {
		transform: rotate(360deg);
	}
}
